// extracted by mini-css-extract-plugin
module.exports = {"productCategoryCell":"TagCell_productCategoryCell__3dmvY","tagCell":"TagCell_tagCell__2OIPt","tagItem":"TagCell_tagItem__2O-dH","isRed":"TagCell_isRed__1BV59"};